import React from "react";
import PropTypes from "prop-types";
import {connect} from "react-redux";
import {FormattedMessage, injectIntl} from "react-intl";

import Button from "@mui/material/Button";
import CloseIcon from "@mui/icons-material/Close";
import IconButton from "@mui/material/IconButton";

import {getCommonVisualizerType} from "../../../../config";
import {aiTutorialSteps} from "./lookAITutorialConfig";
import {capitalizeFirstLetters} from "../../../../misc/helpers";


const LookAITutorialContent = (props) => {

  const {intl, fabricatorData, closeAiTutorial, aiTutorialStepIndex, setAiTutorialStepIndex} = props;

  if (!aiTutorialSteps[aiTutorialStepIndex]) {
    return null // just in case
  }

  const visualizerTypeTranslate = intl.formatMessage({id: "rooms." + getCommonVisualizerType()});

  return (
    <div className="look-intro2__box-content text-center look-intro2__box--with-shadow color-active_text">
      <IconButton aria-label={intl.formatMessage({id: "iconButton.close"})}
                  className="look-icon look-icon--small absolute right-05 top-05 look-icon--gray8 rounded-full"
                  onClick={closeAiTutorial}>
        <CloseIcon/>
      </IconButton>
      <h2 className="look-intro__box-title mt-0 mb-1">
        <FormattedMessage id={aiTutorialSteps[aiTutorialStepIndex].title} values={{
          visualizerType: capitalizeFirstLetters(visualizerTypeTranslate),
        }}/>
      </h2>
      <p className="look-intro__box-text h-auto leading-125 mb-1">
        <FormattedMessage id={aiTutorialSteps[aiTutorialStepIndex].text} values={{
          visualizerType: visualizerTypeTranslate,
        }}/>
      </p>
      {aiTutorialStepIndex === 2 ? (
        <p className="look-intro__box-text h-auto leading-125 mb-1">
          <span className="bold"><FormattedMessage id="look.ai.intro.tip"/>: </span>
          <span className="italic"><FormattedMessage id="look.ai.intro.tipText"/></span>
        </p>
      ) : null}
      <div className="look-intro__box-buttons">
        <Button className={"look-button look-button--140 look-button--no-transform look-button--no-padding "
          + (fabricatorData.isAmericanStandard ? "look-button--primary2" : "look-button--blue")}
                onClick={setAiTutorialStepIndex}>
          <FormattedMessage id={aiTutorialSteps[aiTutorialStepIndex].buttonText}/>
        </Button>
      </div>
    </div>
  )
};

LookAITutorialContent.propTypes = {
  closeAiTutorial: PropTypes.func.isRequired,
  setAiTutorialStepIndex: PropTypes.func.isRequired,
  aiTutorialStepIndex: PropTypes.number.isRequired,
}

const mapStateToProps = (store) => {
  return {
    fabricatorData: store.fabricatorState,
  };
};

export default injectIntl(
  connect(mapStateToProps)(LookAITutorialContent)
)
